import type { Gallery_Slider } from "~/core";

export const isGallerySlider = (item: unknown): item is Gallery_Slider => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "gallery_slider"
  );
};
